import { ActionDescriptor } from '../common/commonTypes';
import AddAttributeForm from './SubtractAttributeForm';

const subtractAttribute: ActionDescriptor = {
	FormComponent: AddAttributeForm,
	actionTitle: 'Subtract',
};

export default subtractAttribute;
